import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Linkedin, Instagram, Facebook, MessageCircle } from "lucide-react";
import { BRAND, PRODUCTS } from "../data/site";

export default function Footer() {
    return (
        <footer data-testid="site-footer" className="bg-[oklch(0.16_0_0)] text-white">
            <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:px-10">
                <div className="grid gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-4">
                        <div className="flex items-center gap-3">
                            <span className="grid h-12 w-12 place-items-center overflow-hidden rounded-2xl bg-black ring-1 ring-white/15">
                                <img src={BRAND.logo} alt="RP Traders" className="h-full w-full object-cover" />
                            </span>
                            <div className="leading-tight">
                                <div className="font-display text-xl font-bold">
                                    RP <span className="rp-text-gradient">Traders</span>
                                </div>
                                <div className="text-[11px] uppercase tracking-[0.2em] text-white/60">
                                    Spice Exporters · Est. {BRAND.established}
                                </div>
                            </div>
                        </div>
                        <p className="mt-6 max-w-md text-sm leading-relaxed text-white/70">
                            Premium Indian spices and agro commodities exporter from Guntur,
                            Andhra Pradesh. Red chilli, turmeric, coriander, cumin and more —
                            shipped worldwide under IEC, FSSAI and Spices Board registrations.
                        </p>
                        <div className="mt-6 flex items-center gap-3">
                            <a
                                href={`https://wa.me/${BRAND.leadWhatsapp}`}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="footer-wa"
                                className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-3 py-2 text-xs font-semibold text-white"
                            >
                                <MessageCircle className="h-3.5 w-3.5" /> +91 94910 85798
                            </a>
                            {[Linkedin, Instagram, Facebook].map((Ic, i) => (
                                <a
                                    key={i}
                                    href="#"
                                    data-testid={`footer-social-${i}`}
                                    className="grid h-9 w-9 place-items-center rounded-full bg-white/8 text-white/80 hover:bg-white/15 hover:text-white"
                                >
                                    <Ic className="h-4 w-4" />
                                </a>
                            ))}
                        </div>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="text-xs uppercase tracking-[0.2em] text-white/60">Products</div>
                        <ul className="mt-5 space-y-3 text-sm">
                            {PRODUCTS.map((p) => (
                                <li key={p.slug}>
                                    <Link
                                        to={`/products/${p.slug}`}
                                        data-testid={`footer-prod-${p.slug}`}
                                        className="text-white/80 hover:text-white"
                                    >
                                        {p.name}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-2">
                        <div className="text-xs uppercase tracking-[0.2em] text-white/60">Company</div>
                        <ul className="mt-5 space-y-3 text-sm">
                            <li><Link to="/" className="text-white/80 hover:text-white">Home</Link></li>
                            <li><a href="/#about" className="text-white/80 hover:text-white">About</a></li>
                            <li><a href="/#certs" className="text-white/80 hover:text-white">Certifications</a></li>
                            <li><a href="/#global" className="text-white/80 hover:text-white">Global Reach</a></li>
                            <li><Link to="/contact" className="text-white/80 hover:text-white">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="lg:col-span-3">
                        <div className="text-xs uppercase tracking-[0.2em] text-white/60">Offices</div>
                        <div className="mt-5 space-y-5 text-sm">
                            <div className="flex items-start gap-3">
                                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-turmeric" />
                                <div>
                                    <div className="font-medium text-white">Head Office · Guntur</div>
                                    <div className="text-white/65">{BRAND.head}</div>
                                </div>
                            </div>
                            <div className="flex items-start gap-3">
                                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-brand-turmeric" />
                                <div>
                                    <div className="font-medium text-white">Branch Office · Hyderabad</div>
                                    <div className="text-white/65">{BRAND.branch}</div>
                                </div>
                            </div>
                            <div className="flex items-center gap-3 text-white/80">
                                <Mail className="h-4 w-4 text-brand-turmeric" />
                                <a href={`mailto:${BRAND.email}`} className="hover:text-white">{BRAND.email}</a>
                            </div>
                            <div className="flex items-center gap-3 text-white/80">
                                <Phone className="h-4 w-4 text-brand-turmeric" />
                                <a href={`tel:+${BRAND.phoneIntl}`} className="hover:text-white">{BRAND.phone}</a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-16 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-white/55 sm:flex-row sm:items-center sm:justify-between">
                    <div>© {new Date().getFullYear()} RP Traders. All rights reserved.</div>
                    <div className="flex flex-wrap items-center gap-x-5 gap-y-1">
                        <span>GSTN {BRAND.gstn}</span>
                        <span className="hidden sm:inline">·</span>
                        <span>IEC · FSSAI · Spices Board Registered Exporter</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}
